import { createStore, applyMiddleware, compose } from 'redux';
import { composeWithDevTools } from '@redux-devtools/extension';
import thunk from 'redux-thunk';

import { RAPYD_HOSTNAMES } from 'consts';
import reducers from './reducers';
// TODO: check if can import *
import {
  collect,
  beneficiaryTokenization,
  issuing,
  idv,
  global,
  korta,
  resetPIN,
  viewPIN,
  otp,
  activateIssuingCard,
  fullStory
} from './middlewares';

const configureStore = () => {
  const middlewares = [
    thunk,
    fullStory,
    collect,
    beneficiaryTokenization,
    issuing,
    idv,
    global,
    korta,
    resetPIN,
    viewPIN,
    otp,
    activateIssuingCard
  ];
  const isProd = RAPYD_HOSTNAMES.includes(
    window.location.hostname || window.location.host
  );
  const composeFunc = isProd
    ? compose
    : composeWithDevTools({ trace: true, traceLimit: 25 });

  return createStore(reducers, composeFunc(applyMiddleware(...middlewares)));
};

export default configureStore();
